import { Screen, ScreenHeader, Display, Lede, Btn } from "../ui/components";
import { Ico } from "../ui/Ico";
import { C, mono } from "../ui/tokens";

export function WrongDomain({ email, onRetry }: { email: string; onRetry: () => void }) {
  return (
    <Screen>
      <ScreenHeader title="Spesen · Anmeldung" />
      <Display>Falsches<br />Konto</Display>
      <Lede>Diese App ist nur für Bitforge-Konten. Melde dich mit deiner @bitforge.ch-Adresse an.</Lede>

      <div style={{
        marginTop: 24, padding: "14px 16px",
        background: C.surface, border: `1px solid ${C.border}`, borderRadius: 16,
      }}>
        <div style={{
          fontSize: 11, color: C.fg3, letterSpacing: "0.18em",
          textTransform: "uppercase", marginBottom: 6,
        }}>Angemeldet als</div>
        <div style={{ fontFamily: mono, fontSize: 14, color: C.fg, wordBreak: "break-all" }}>{email}</div>
      </div>

      <div style={{ marginTop: 20 }}>
        <Btn onClick={onRetry} icon={<Ico name="arrow" size={18} color="#000" />}>
          Anderes Konto verwenden
        </Btn>
      </div>
    </Screen>
  );
}
